import {ObjectBuilder} from '@gongxigames/framework/core';
import {Container, Sprite} from 'pixi.js';

export type PanelUpdateOptions = {
    width: number;
    separators: number;
    buttonVerticalPadding: number;
    buttonHorizontalPadding: number;
};

export type PanelOptions = {
    objectBuilder: ObjectBuilder;
};

export type PanelPosition = {
    width: number;
    height: number;
    x: number;
    y: number;
};

export class Panel {
    public readonly container: Container = new Container();

    private _config!: PanelUpdateOptions;

    private _separatorWidth = 0;
    // private _panelOffsetStart: number = 0;
    // private _panelOffsetEnd: number = 0;
    // private _panelActiveWidth: number = 0;

    private _panelBgNameStart = 'panel_start';
    private _panelBgNameEnd = 'panel_end';
    private _panelBgNameBody = 'panel_body';
    private _panelBgNameSeparator = 'panel_separator';

    private _panelBgStart: Sprite ;
    private _panelBgEnd: Sprite ;
    private _panelBgBody: Sprite ;
    private _panelBgSeparators: Sprite[] = [];

    constructor(private readonly _objectBuilder: ObjectBuilder) {
        this._panelBgStart = _objectBuilder.buildImage({src: this._panelBgNameStart});
        this._panelBgEnd = _objectBuilder.buildImage({src: this._panelBgNameEnd});
        this._panelBgBody = _objectBuilder.buildImage({src: this._panelBgNameBody});

        this.container.addChild(this._panelBgStart);
        this.container.addChild(this._panelBgEnd);
        this.container.addChild(this._panelBgBody);
    }

    public update(config: PanelUpdateOptions): PanelPosition[] {
        this._config = config;
        this.setSeparators();
        this.updatePanel();

        const positions = this.updateSeparators();

        return positions;
    }

    private setSeparators(): void {
        const newSeparators = [];
        const oldSeparators = this._panelBgSeparators;
        const {separators} = this._config;

        for (let i = 0; i < separators; i++) {
            const separator = oldSeparators.pop() || this._objectBuilder.buildImage({src: this._panelBgNameSeparator});

            newSeparators.push(separator);
        }

        oldSeparators.forEach(separator => this.container.removeChild(separator));

        this._panelBgSeparators = newSeparators;
        this._separatorWidth = separators ? newSeparators[0].width : 0;
    }

    private updateSeparators(): PanelPosition[] {
        const {width, separators, buttonVerticalPadding, buttonHorizontalPadding} = this._config;
        const separatorWidth = this._separatorWidth;

        const offsetStart = this._panelBgStart.width + buttonHorizontalPadding;
        const offsetEnd = this._panelBgEnd.width + buttonHorizontalPadding;
        const activeWidth = width - offsetStart - offsetEnd;

        const segmentSize = (activeWidth - (separators * separatorWidth)) / (separators + 1);
        const positions: PanelPosition[] = [];
        const buttonHeight = this._panelBgBody.height - (buttonVerticalPadding * 2);

        this._panelBgSeparators.forEach((separator, i) => {
            const offset = offsetStart + segmentSize + (separatorWidth + segmentSize) * i;

            separator.x = offset;
            this.container.addChild(separator);
        });

        for (let i = 0; i < separators + 1; i++) {
            const positionOffset = i * (segmentSize + separatorWidth) + offsetStart;

            positions.push({width: segmentSize, height: buttonHeight, x: positionOffset, y: buttonVerticalPadding});
        }

        return positions;
    }

    private updatePanel(): void {
        const widthStart = this._panelBgStart.width;
        const widthEnd = this._panelBgEnd.width;
        const width = this._config.width - widthStart - widthEnd;

        this._panelBgStart.x = 0;

        this._panelBgBody.width = width;
        this._panelBgBody.x = widthStart;

        this._panelBgEnd.x = widthStart + width;
    }
}
